export enum BriefTypeSend {
  All = 'all',
  Provider = 'provider',
}